module.exports = __webpack_public_path__ + "0f1fd5301f2fbf7fa230eb69b1dcec3d.MP3";